import { cn } from "@/lib/utils";
import { clamp01, strengthWord } from "./labels";

// Conviction / gap size / disagreement strength → a labelled bar, never a decimal.
// Single teal fill on a muted track; the *length* carries the meaning, with a word beside it.
// (Hand-rolled rather than the shadcn Progress because this theme's `--secondary` track is
// pure white, which would render an invisible track.)
export function StrengthBar({
  value,
  label,
  showWord = true,
  width = "w-24",
  className,
}: {
  value: number | null | undefined;
  /** Overrides the auto strength word, e.g. "case against". */
  label?: string;
  showWord?: boolean;
  width?: string;
  className?: string;
}) {
  const v = clamp01(value);
  const word = label ?? strengthWord(value);
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div
        className={cn("h-2 rounded-full bg-muted overflow-hidden shrink-0", width)}
        role="meter"
        aria-valuemin={0}
        aria-valuemax={1}
        aria-valuenow={v}
        aria-label={word}
      >
        <div className="h-full rounded-full bg-primary transition-all" style={{ width: `${v * 100}%` }} />
      </div>
      {showWord && <span className="text-xs text-muted-foreground font-body whitespace-nowrap">{word}</span>}
    </div>
  );
}
